type Options = {
  target?: '_blank' | '_self';
  isReferrerHidden?: boolean;
};

export const openExternalUrl = (
  url: string,
  { target = '_blank', isReferrerHidden = false }: Options = {},
): boolean => {
  if (target === '_self') {
    window.open(url, '_self');
    return true;
  }
  if (isReferrerHidden) {
    window.open(url, '_blank', 'noopener,noreferrer');
    return true;
  }
  const opened = window.open(url, '_blank');
  if (!opened) return false;
  opened.opener = null;
  return true;
};
